import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import UnorderedListOutlinedSvg from "@ant-design/icons-svg/es/asn/UnorderedListOutlined";
import AntdIcon from "../components/AntdIcon";
var UnorderedListOutlined = function UnorderedListOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UnorderedListOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  UnorderedListOutlined.displayName = 'UnorderedListOutlined';
}
export default /*#__PURE__*/React.forwardRef(UnorderedListOutlined);